module.exports = __webpack_public_path__ + "static/media/layout-four-1.34c6010a.jpg";